module.exports = __webpack_public_path__ + "ClientApp/content/Lap-of-love-veterinary-care-coordinator-1.jpg";